import Home from "../assets/Home.svg"
import Fees from "../assets/Fees.svg"
import Bulb from "../assets/Bulb.svg"

function Solutions() {
  return (
    <div className="solution-section" id="solutions">
         <div className="solution-section-header">
         <h3>Why Choose Payourl</h3>
          <p>
          Card payments are costly, slow and can sometimes be unreliable.
          </p>
         </div>
         <div className="solution-section-card-group">
            <div className=" solution-card">
              <img src={Fees} alt="fees" />
              <h4>
                Low Transactional Fees
              </h4>
              <p>
              We charge 1.2% for both local and global transactions and offer free withdrawal with no gas fee.
              </p>
            </div>
            <div className="solution-card">
              <img src={Home} alt="fees" />
              <h4>
              Global Payments
              </h4>
              <p>
              Accept payments from anywhere in the world and get paid in your local currency.
              </p>
            </div>
            <div className="solution-card">
              <img src={Bulb} alt="fees" />
              <h4>
               Free Setup
              </h4>
              <p>
              You don’t have to pay to create an account. Payourl setups are completely free.
              </p>
            </div>
            <div className="solution-card">
              <img src={Bulb} alt="fees" />
              <h4>
               Book-keeping
              </h4>
              <p>
              We help you keep track of all payments received. And everyone who pays you gets a receipt, you get a receipt too (obviously!)
              </p>
            </div>
         </div>
        </div>
  )
}

export default Solutions